'use client';
import {ThemeProvider, ThemeSettingsProvider} from './providers';
import {PropsWithChildren} from 'react';

export const KEITheme = ({children}: PropsWithChildren) => {
  return (
    <ThemeSettingsProvider>
      <ThemeProvider>{children}</ThemeProvider>
    </ThemeSettingsProvider>
  );
};
